import { defineMessages } from 'react-intl';

export default defineMessages({ 
    privacyDisclosureTextPart1: {
        id: 'privacyDisclosure1.text.part1',
        defaultMessage: 'If you do not want your nonpublic personal financial information disclosed by the Texas Windstorm Insurance Association, please complete the information below.'
    },
    privacyDisclosureTextPart2: {
        id: 'privacyDisclosure1.text.part2',
        defaultMessage: 'For more information about what we collect and how we use it, or if you wish to mail in the Disclosure Limitation Reply Form, please view our '
    }    
});
